(function () {
  'use strict';

  var REVISION = '2024-10-15';

  function initForm(form) {
    if (!form || form.dataset.odditKlaviyoReady === 'true') return;
    var company = form.getAttribute('data-klaviyo-company');
    var listId = form.getAttribute('data-klaviyo-list');
    if (!company || !listId) return; // not configured → leave native form alone
    form.dataset.odditKlaviyoReady = 'true';

    var emailInput = form.querySelector('input[type="email"]');
    var button = form.querySelector('[type="submit"]');
    var label = form.querySelector('[data-button-label]');
    var successMessage = form.getAttribute('data-success-message') || 'Thanks for subscribing.';
    var errorMessage = form.getAttribute('data-error-message') || 'Something went wrong. Please try again.';

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (!emailInput || !emailInput.value || !emailInput.checkValidity()) {
        if (emailInput) emailInput.reportValidity();
        return;
      }

      var originalLabel = label ? label.textContent : '';
      if (button) button.disabled = true;
      if (label) label.textContent = 'Submitting…';

      subscribe(company, listId, emailInput.value)
        .then(function () {
          showMessage(form, successMessage, true);
          form.reset();
        })
        .catch(function () {
          showMessage(form, errorMessage, false);
        })
        .then(function () {
          if (button) button.disabled = false;
          if (label) label.textContent = originalLabel;
        });
    });
  }

  function subscribe(company, listId, email) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Newsletter Form',
          profile: {
            data: {
              type: 'profile',
              attributes: { email: email }
            }
          }
        },
        relationships: {
          list: { data: { type: 'list', id: listId } }
        }
      }
    };

    return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(company), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: REVISION
      },
      body: JSON.stringify(payload)
    }).then(function (res) {
      // Klaviyo returns 202 Accepted on success.
      if (!res.ok && res.status !== 202) throw new Error('Klaviyo subscribe failed: ' + res.status);
      return res;
    });
  }

  function showMessage(form, text, isSuccess) {
    var el = form.querySelector('[data-newsletter-message]');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-newsletter-message', '');
      el.className = 'oddit-section-newsletter-form__message';
      form.appendChild(el);
    }
    el.textContent = text;
    el.classList.toggle('oddit-section-newsletter-form__message--success', isSuccess);
    el.classList.toggle('oddit-section-newsletter-form__message--error', !isSuccess);
    el.setAttribute('role', isSuccess ? 'status' : 'alert');
  }

  function initAll(root) {
    (root || document)
      .querySelectorAll('.oddit-section-newsletter-form__form[data-klaviyo-company]')
      .forEach(initForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target) initAll(e.target);
  });
})();
